import React from 'react';
import rec from '../../assets/images/IRDA Registration Certificate_339_27.11.2024 to 26.11.2027 (1)_page-0001.jpg';

function Recipt() {
  return (
    <div>
      <img src={rec} alt="Recipt" />
    </div>
  );
}

export default Recipt;
